/**
 * Flavor Cart Handler
 * Handles the connection between the flavor quantity selector, subscription widget, and cart form
 */
document.addEventListener('DOMContentLoaded', () => {
  const flavorSelector = document.querySelector('[data-flavor-quantity-selector]');
  if (!flavorSelector) return;

  const buyButton = document.querySelector('buy-buttons button');
  const productForm = document.querySelector('form[is="product-form"]');
  
  let currentSelections = [];
  let currentTotalPrice = 0;
  let currentTotalQuantity = 0;

  // Listen for flavor selection changes
  document.addEventListener('flavor-selection-changed', (event) => {
    const { selections, totalPrice, totalCompareAtPrice, totalQuantity } = event.detail;
    currentSelections = selections;
    currentTotalPrice = totalPrice;
    currentTotalQuantity = totalQuantity;

    // Update buy button state and price
    updateBuyButtonState();
    updateBuyButtonPrice(totalPrice, totalCompareAtPrice);
  });

  function updateBuyButtonState() {
    if (!buyButton) return;
    
    // Enable/disable button based on selections
    if (currentTotalQuantity === 0) {
      buyButton.setAttribute('disabled', 'disabled');
    } else {
      buyButton.removeAttribute('disabled');
    }
  }

  function updateBuyButtonPrice(totalPrice, totalCompareAtPrice) {
    const priceElement = document.querySelector('[data-pack-price]');
    const comparePriceElement = document.querySelector('[data-pack-price-subdued]');
    
    if (!priceElement) return;

    // Check if subscription is selected
    const subscriptionWidget = document.querySelector('subscription-widget');
    const isSubscriptionSelected = subscriptionWidget?.querySelector('.subscription-widget__option--subscription.subscription-widget__option--selected');
    
    let finalPrice = totalPrice;
    
    if (isSubscriptionSelected) {
      // Get subscription discount from the selected plan
      const select = subscriptionWidget.querySelector('.deployer-select');
      if (select) {
        const selectedOption = select.options[select.selectedIndex];
        const adjustementType = selectedOption.dataset.ajustmentType;
        const adjustementValue = parseFloat(selectedOption.dataset.ajustmentValue);

        switch (adjustementType) {
          case 'fixed_amount':
            finalPrice = totalPrice - (adjustementValue * currentTotalQuantity);
            break;
          case 'percentage':
            finalPrice = totalPrice * (1 - adjustementValue / 100);
            break;
          case 'price':
            finalPrice = adjustementValue * currentTotalQuantity;
            break;
        }
      }
    }
    
    priceElement.textContent = formatPrice(finalPrice);
    
    if (comparePriceElement) {
      if (totalCompareAtPrice && totalCompareAtPrice > finalPrice) {
        comparePriceElement.textContent = formatPrice(totalCompareAtPrice);
        comparePriceElement.style.display = '';
      } else if (isSubscriptionSelected && totalPrice > finalPrice) {
        // Show original price as compare price for subscription
        comparePriceElement.textContent = formatPrice(totalPrice);
        comparePriceElement.style.display = '';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  // Format price helper (same as subscription-widget.js)
  function formatPrice(priceInCents) {
    const price = priceInCents / 100;
    if (price % 1 === 0) {
      return price.toLocaleString('fr-FR') + ' €';
    }
    return price.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  // Intercept form submission
  if (buyButton && productForm) {
    buyButton.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Check if we have items to add
      if (!currentSelections || currentSelections.length === 0) {
        const flavorMessage = document.querySelector('[data-msg-choose-flavor]')?.getAttribute('data-msg-choose-flavor') || '';
        showError(flavorMessage);
        return;
      }

      // Set loading state
      buyButton.setAttribute('aria-busy', 'true');

      // Get selling plan from form
      let sellingPlanId = null;
      const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        sellingPlanId = sellingPlanInput.value;
      }

      // Build cart items
      const cartItems = currentSelections.map(selection => {
        const item = {
          id: parseInt(selection.variantId),
          quantity: selection.quantity
        };

        if (sellingPlanId) {
          item.selling_plan = parseInt(sellingPlanId);
        }

        return item;
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: cartItems,
            sections: ['variant-added', 'cart-drawer']
          })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Erreur lors de l\'ajout au panier');
        }

        const result = await response.json();
        
        // Dispatch cart refresh event
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: result
          }
        }));

        // Open cart drawer
        if (document.querySelector('.cart-drawer')) {
          document.querySelector('.cart-drawer').show();
        } else if (window.SLIDECART_UPDATE && window.SLIDECART_OPEN) {
          window.SLIDECART_UPDATE();
          window.SLIDECART_OPEN();
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        showError(error.message || 'Erreur lors de l\'ajout au panier');
      } finally {
        buyButton.setAttribute('aria-busy', 'false');
      }
    });
  }

  function showError(message) {
    document.querySelectorAll('[data-hb-sticky-error], [data-hb-offer-error]').forEach((element) => {
      element.textContent = message || '';
      element.hidden = !message;
    });

    // Try to find existing error container
    let errorContainer = document.querySelector('.fl-packs__error-message');
    let errorElement = document.querySelector('[data-pack-error-message]');
    
    if (errorContainer && errorElement) {
      errorElement.textContent = message;
      errorContainer.classList.remove('fl-hidden');
      setTimeout(() => {
        errorContainer.classList.add('fl-hidden');
        document.querySelectorAll('[data-hb-sticky-error], [data-hb-offer-error]').forEach((element) => {
          element.hidden = true;
          element.textContent = '';
        });
      }, 5000);
    } else {
      // Create a simple error banner
      const banner = document.createElement('div');
      banner.classList.add('banner', 'banner--error', 'justify-center');
      banner.setAttribute('role', 'alert');
      banner.style.cssText = 'grid-column: 1/-1; margin-bottom: 1rem; padding: 0.5rem; background: #fee2e2; border-radius: 6px; text-align: center;';
      banner.innerHTML = `<p style="margin:0;">${message}</p>`;
      
      const buyButtons = document.querySelector('buy-buttons');
      if (buyButtons) {
        buyButtons.before(banner);
        setTimeout(() => banner.remove(), 5000);
      }
    }
  }

  // Initial state
  updateBuyButtonState();
});

